import { DefaultCell } from "../../Component/Common/Components/DataTable/DefaultCell";
import { ActionType, TableColumn } from "../../Component/Model/Table/Table";
import { BEEScorecardUserAccess } from "../../Component/Model/Dto/Scorecard/BEEScorecardUserAccessDto";
import { userRolesState } from "../../State/user.Atom";
import { useRecoilValue } from "recoil";
import { SiteAdminRole, SubAdminRole, UserAdminRole } from "../../Component/Common/Constants/UserRoles";
import { ActionsCell } from "../../Component/Common/Components/DataTable/ActionsCell";

interface LinkedUserRow {
    userId: string;
    fullName: string;
    email: string;
    userType: string;
    action: ActionType[];
}

interface LinkedUserTable {
    columns: Array<TableColumn>;
    rows: Array<LinkedUserRow>;
}

export function LinkedUserTableMapper(dataObject: BEEScorecardUserAccess.linkedUsers[], deleteLinkedUser: (id: number) => void): LinkedUserTable {
    const userRoles = useRecoilValue(userRolesState);

    function getActionButton(item: BEEScorecardUserAccess.linkedUsers, index: number): ActionType[] {
        const actions: ActionType[] = [];
        if ((userRoles.includes(SiteAdminRole) || userRoles.includes(UserAdminRole) || userRoles.includes(SubAdminRole))) {
            actions.push(
                {
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        deleteLinkedUser(index);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                }
            )
        }
        return actions;
    }
    
    const columns = [
        { Header: 'Full Name', accessor: 'fullName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} maxWidth={"300px"} /> },
        { Header: 'Email', accessor: 'email', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'User Type', accessor: 'userType', Cell: ({ value }: any) => <DefaultCell value={value} /> ,disableSortBy: true},
        { Header: 'Action', accessor: 'action', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];

    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((linkedUser, index) => ({
            userId: linkedUser.userId,
            fullName: linkedUser.name,
            email: linkedUser.email,
            userType: linkedUser.userTypeDescription,
            action: getActionButton(linkedUser, index),
            Style: { background: linkedUser.isNewLinkedUser ? '#C1DCE0' : 'White' }
        }));

        return { columns: columns, rows: rows };

    } else {
        return { columns: columns, rows: [] };
    }
}